import { useQuery } from '@apollo/client';
import { defineMessages, useIntl } from 'react-intl';
import Layout from '../modules/Layout';
import { Container } from '../components';
import OrderConfirmation from '../modules/OrderConfirmation';
import {
  orderConfirmationQuery,
  orderConfirmationQueryVariables
} from '../core-types';
import { CustomNextPage } from '../lib/types';
import { getQueryString } from '../lib/utils';
import { gql } from '@apollo/client';
import { bootstrap } from '../lib/bootstrap';
import { RECEIPT_ORDER_FRAGMENT } from '../lib/core/orderFragment';

const messages = defineMessages({
  title: {
    id: 'pages.order-confirmation.title',
    defaultMessage: 'Order confirmation'
  }
});

const ORDER_CONFIRMATION_QUERY = gql`
  ${RECEIPT_ORDER_FRAGMENT}
  query orderConfirmationQuery($orderToken: String!) {
    receiptPage {
      title
      orderTitle
    }
    order(token: $orderToken) {
      ...ReceiptOrder
    }
  }
`;

const OrderConfirmationPage: CustomNextPage<{
  token: string;
  statusCode?: number;
}> = ({ url, token, statusCode }) => {
  const intl = useIntl();
  const { data, loading } = useQuery<
    orderConfirmationQuery,
    orderConfirmationQueryVariables
  >(ORDER_CONFIRMATION_QUERY, {
    variables: {
      orderToken: token
    }
  });
  return (
    <Layout
      statusCode={statusCode}
      type="article"
      title={
        data && data.receiptPage && data.receiptPage.title
          ? data.receiptPage.title
          : intl.formatMessage(messages.title)
      }
      url={url}
      loading={loading}
      render={() => {
        if (!data || !data.receiptPage || !data.order) {
          return null;
        }
        return (
          <Container variant="narrow">
            <OrderConfirmation
              order={data.order}
              receiptPage={data.receiptPage}
            />
          </Container>
        );
      }}
    />
  );
};

OrderConfirmationPage.getInitialProps = async ctx => {
  const token = getQueryString(ctx.query.token);
  if (!token) {
    const err = new Error(`Page not found`);
    err.code = 'ENOENT';
    throw err;
  }
  const orderPageQueryResult = await ctx.apolloClient.query<
    orderConfirmationQuery,
    orderConfirmationQueryVariables
  >({
    query: ORDER_CONFIRMATION_QUERY,
    variables: { orderToken: token }
  });
  let statusCode;
  if (
    !orderPageQueryResult.data ||
    !orderPageQueryResult.data.order ||
    !orderPageQueryResult.data.receiptPage
  ) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode,
    token
  };
};

export default bootstrap(OrderConfirmationPage);
